module.exports = __webpack_public_path__ + "static/media/stinger.4332310d.png";